// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"35":"internal/shell","734":"internal/rollbacks","855":"internal/developer-previews","966":"login"}[chunkId] + ".js";
};